pathType